import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from '@/lang/zh'
import en from '@/lang/en'
import enLocale from 'element-ui/lib/locale/lang/en' //引入Element UI的英文包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入Element UI的中文包


Vue.use(VueI18n)

const locale = localStorage.getItem('locale') || 'en'

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en',
  messages: {
    zh: {
      ...zh,
      ...zhLocale
    },
    en: {
      ...en,
      ...enLocale
    }
  }
})

// Hot updates
if (module.hot) {
  module.hot.accept(['./lang/zh', './lang/en'], function () {
    i18n.setLocaleMessage('zh', require('./lang/zh').default)
    i18n.setLocaleMessage('en', require('./lang/en').default)
  })
}

export default i18n
